import { HoverScaleBackground, HoverScaleContent, hoverScaleProps } from "@Components/common/hover-scale-button";
import HapticsButtonWrapper from "@Components/generic/haptics-button-wrapper";
import Icon from "@Components/generic/icon";
import { faBackspace } from "@fortawesome/pro-solid-svg-icons";
import { ButtonBase, Stack, styled, Typography } from "@mui/material";

const CharacterButton = styled(ButtonBase)(({ theme }) => ({
  position: "relative",
  padding: theme.spacing(0.75, 0.625),
  color: theme.palette.dsBase.v200,
  fontWeight: 600,
}));

interface CharacterInputGridProps {
  characters: string[];
  onCharacterClick: (char: string) => void;
  onBackspace?: () => void;
  buttonWidth?: number;
}

const CharacterInputGrid = ({ characters, onCharacterClick, onBackspace, buttonWidth = 32 }: CharacterInputGridProps) => {
  return (
    <Stack direction="row" spacing={0.5} sx={{ flexWrap: "wrap", justifyContent: "center", gap: 1 }}>
      {characters.map((char) => (
        <HapticsButtonWrapper key={char}>
          <CharacterButton
            onClick={() => onCharacterClick(char)}
            sx={(theme) => ({
              borderRadius: theme.spacing(1),
              width: buttonWidth,
            })}
          >
            <HoverScaleBackground {...hoverScaleProps} sx={(theme) => ({ borderRadius: theme.spacing(1) })} />
            <HoverScaleContent>
              <Typography variant="text2xl500" color="dsNeutral.v300">
                {char}
              </Typography>
            </HoverScaleContent>
          </CharacterButton>
        </HapticsButtonWrapper>
      ))}

      {onBackspace && (
        <HapticsButtonWrapper>
          <CharacterButton
            onClick={onBackspace}
            sx={(theme) => ({
              borderRadius: theme.spacing(1),
              width: 40,
            })}
          >
            <HoverScaleBackground {...hoverScaleProps} sx={(theme) => ({ borderRadius: theme.spacing(1) })} />
            <HoverScaleContent>
              <Icon icon={faBackspace} sx={{ color: "dsNeutral.v300" }} fontSize={24} />
            </HoverScaleContent>
          </CharacterButton>
        </HapticsButtonWrapper>
      )}
    </Stack>
  );
};

export default CharacterInputGrid;
